<label *ngIf="attribute.intervalInDomain" class="cx-intervalHelpText">{{
  this.getHelpTextForInterval()
}}</label>
<div id="{{ createAttributeIdForConfigurator(attribute) }}" class="form-group">
  <input
    [formControl]="attributeInputForm"
    class="form-control"
    [ngClass]="{
      'cx-required-error-msg ': (showRequiredErrorMessage$ | async),
    }"
    [class.ng-invalid]="isRequired && isUserInputEmpty"
    [attr.aria-describedby]="
      mustDisplayValidationMessage()
        ? createAttributeUiKey('label', attribute.name) +
          ' ' +
          createAttributeUiKey('attribute-msg', attribute.name)
        : createAttributeUiKey('label', attribute.name)
    "
    attr.role="{{ attribute.dataType }}"
    [attr.required]="attribute.required === true ? 'required' : null"
    (change)="onChange()"
    maxlength="{{ attribute.maxlength }}"
    [attr.aria-label]="getAriaLabelComplete()"
    [cxFocus]="{
      key: createAttributeIdForConfigurator(attribute),
    }"
  />
</div>
<div
  class="cx-validation-msg"
  id="{{ createAttributeUiKey('attribute-msg', attribute.name) }}"
  *ngIf="mustDisplayValidationMessage()"
  aria-live="assertive"
  aria-atomic="true"
  role="alert"
>
  <cx-icon [type]="iconType.ERROR"></cx-icon>
  {{
    'configurator.attribute.wrongNumericFormatMessage'
      | cxTranslate: { pattern: numericFormatPattern }
  }}
</div>
<div
  class="cx-validation-msg"
  id="{{ createAttributeUiKey('attribute-msg', attribute.name) }}"
  *ngIf="mustDisplayIntervalMessage()"
  aria-live="assertive"
  aria-atomic="true"
  role="alert"
>
  <cx-icon [type]="iconType.ERROR"></cx-icon>
  {{ 'configurator.attribute.wrongIntervalFormat' | cxTranslate }}
</div>
